<template>
  <div class="blogMaintenanceWrap mainPageBg">
    <div class="upContent">
      <div class="uploadBox">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="addBtn"
          >新增博客</el-button
        >
      </div>
      <div
        class="listBox commonWrap"
        v-loading="$store.state.user.loadingState"
      >
        <template v-if="list.length">
          <div class="leftMenu">
            <PublicListCom :list="list" @getActiveTitle="getActiveTitle" />
          </div>
          <div class="rightContent">
            <div class="operation">
              <h3>{{ detailsData.title }}</h3>
              <div>
                <el-button
                  type="primary"
                  icon="el-icon-delete"
                  size="mini"
                  @click="handleClose"
                ></el-button>
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="editBtn"
                ></el-button>
              </div>
            </div>
            <div class="showContent">
              <p v-html="detailsData.details">{{ detailsData.details }}</p>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty description="暂无博客" style="margin: 0 auto"></el-empty>
        </template>
      </div>
    </div>
    <AddEditBlog
      :dialogVisible="dialogVisible"
      :title="title"
      v-if="dialogVisible"
      @getAddBolg="getAddBolg"
    />
  </div>
</template>

<script>
import PublicListCom from "@/components/guanlizhidu/PublicListCom";
import AddEditBlog from "@/components/xiangmulicheng/AddEditBlog";
import api from "@/api";
import axios from "axios";
export default {
  components: {
    PublicListCom,
    AddEditBlog,
  },
  data() {
    return {
      dialogVisible: false,
      title: "",
      list: [],
      detailsData: {},
      active: 0,
      httpUrl: "",
      tokenString: "",
    };
  },
  methods: {
    async getAddBolg(data) {
      let formdata = new FormData();
      let str = new Blob([data.txtContent], {
        type: "text/plain;charset=utf-8",
      });
      formdata.append("file", str);
      // console.log(formdata.get("file"));
      if (this.title == "编辑") {
        axios
          .post(
            this.httpUrl +
              `/api/juji/project/blog/modify?oldTitle=${this.detailsData.title}&title=${data.titleTxt}&ts=${this.detailsData.ts}&projectIdStr=${JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId}`,
            formdata,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "X-Authorization": `Bearer ${this.tokenString}`,
              },
            }
          )
          .then((res) => {
            if (res && res.status == 200) {
              this.$message.success("修改成功");
              setTimeout(() => {
                this.getList();
                this.$store.commit("SET_LOADING", false);
                this.dialogVisible = false;
              }, 1000);
            }
          });
      } else {
        axios
          .post(
            this.httpUrl +
              `/api/juji/project/blog/add?title=${data.titleTxt}&projectIdStr=${JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId}`,
            formdata,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "X-Authorization": `Bearer ${this.tokenString}`,
              },
            }
          )
          .then((res) => {
            if (res && res.status == 200) {
              this.$message.success("添加成功");
              this.dialogVisible = false;
              setTimeout(() => {
                this.getList();
                this.$store.commit("SET_LOADING", false);
              }, 2000);
            }
          });
      }
    },
    async getList() {
      this.active = 0;
      let res = await api.developmentGetList({
        projectIdStr: JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId,
        startTs: 0,
        endTs: new Date().getTime() + 1,
      });
      if (res.status == 200 && res.data.length) {
        this.list = res.data;
        let data = {
          item: this.list[0],
          index: 0,
        };
        this.getActiveTitle(data);
      } else {
        this.list = [];
      }
    },

    async getActiveTitle(data) {
      this.$store.commit("SET_LOADING", true);
      let index = data.item.uri.lastIndexOf("/");
      let str = data.item.uri.substring(index + 1, data.item.uri.length);
      let res = await api.systemOnlinePreview(
        {
          tenant_id: JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId,
        },
        str
      );
      if (res.status == 200 && res.data) {
        this.$store.commit("SET_LOADING", false);
        this.detailsData = data.item;
        this.detailsData.details = res.data;
      }
    },

    handleClose() {
      this.$confirm("确定删除此博客？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            axios
              .post(
                this.httpUrl +
                  `/api/juji/project/blog/delete?projectIdStr=${
                    JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId
                  }&startTs=${this.detailsData.ts}&endTs=${
                    this.detailsData.ts + 1
                  }&deleteFileToo=true`,
                this.detailsData.uri,
                {
                  headers: {
                    "Content-Type": "application/json",
                    "X-Authorization": `Bearer ${this.tokenString}`,
                  },
                }
              )
              .then((res) => {
                if (res && res.status == 200) {
                  this.$message.success("删除成功!");
                  this.getList();
                }
              });
          } else {
          }
        },
      });
    },
    addBtn() {
      this.dialogVisible = true;
      this.title = "新增博客";
    },
    editBtn() {
      this.dialogVisible = true;
      this.title = "编辑";
    },
  },
  created() {
    this.httpUrl = window.jujiParams.baseURL;
    this.tokenString = window.sessionStorage.getItem("token");
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.blogMaintenanceWrap {
  @include setFlexCenter;
  .upContent {
    width: 96%;
    height: 100%;
    @include setFlexColumn;
    align-items: center;
    justify-content: space-around;
    .uploadBox {
      width: 100%;
      height: 55px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
    }
    .listBox {
      width: 100%;
      height: calc(100% - 100px);
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      @include setFlexBetween;
      .leftMenu {
        width: 22%;
        height: 96%;
        overflow: hidden;
      }
      .leftMenu:hover {
        overflow-y: auto;
      }
      .rightContent {
        width: 76%;
        height: 96%;
        margin: 0 auto;
        .operation {
          height: 80px;
          width: 100%;
          @include setFlexBetween;
          h3 {
            height: 80px;
            text-indent: 20px;
            line-height: 80px;
            font-size: 26px;
          }
        }
        .showContent {
          width: 100%;
          height: calc(100% - 80px);
          overflow: auto;
          ::v-deep img {
            width: 50%;
          }
          ::v-deep p {
            margin: 10px 0;
          }

          ::v-deep table {
            border-collapse: collapse;
            td,
            th {
              padding: 10px 30px;
              border: 1px solid #999;
            }
          }
        }
      }
    }
  }
}
</style>